import { create } from "zustand";
import { PersistOptions, persist } from "zustand/middleware";
import { produce } from "immer";
import CryptoJS from 'crypto-js';
import { ResultState, initResult } from "./initialState";
import { CalculatedResultItemProps } from "@/components/Cart/constants";

export const useResultStore = create<ResultState>() (
  persist<ResultState>(
    (set, get) => ({
      resultData: CryptoJS.AES.encrypt(JSON.stringify(initResult), process.env.NEXT_PUBLIC_HASH_CODE!).toString(),
      updateResult: (resultData: CalculatedResultItemProps) => {
        set(
          produce((draft: ResultState) => {
            const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(resultData), process.env.NEXT_PUBLIC_HASH_CODE!).toString();
            draft.resultData = encryptedUser;
          })
        )
      },
      getResult: () => {
        const state = get();

        if (state.resultData.constructor === ({}).constructor) {
          set(
            produce((draft: ResultState) => {
              const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(state.resultData), process.env.NEXT_PUBLIC_HASH_CODE!).toString();
              draft.resultData = encryptedUser;
            })
          )

          return state.resultData;
        } else if (state.resultData.constructor === "text".constructor) {
          try {
            return JSON.parse(CryptoJS.AES.decrypt(state.resultData, process.env.NEXT_PUBLIC_HASH_CODE!).toString(CryptoJS.enc.Utf8));
          } catch (error) {
            return initResult;
          }
        } else {
          return initResult;
        }
      }
    }), {
      name: "resultData"
    } as PersistOptions<ResultState>
  ) 
)
